let bounds = new google.maps.LatLngBounds();
let markers = new Array();
let locations = new Array();
let websitePath = window.location.origin;

function addPlaceDetails(map)
{
	const placesService = new google.maps.places.PlacesService(map);
	placesService.getDetails(
		// request object
		{
			placeId: locations[0].position.placeId,
			fields: ['name', 'rating', 'opening_hours']
		},
		// result callback
		(place, status) =>
		{
			if (status == google.maps.places.PlacesServiceStatus.OK)
			{
				// RATING
				$("#place-rating").html(place.rating);
				$("#place-rating").css('opacity', '1');
				for (var i = 0; i < Math.floor(place.rating); i++)
				{
					$("#place-stars li").eq(i).removeClass();
					//setTimeout(function ()
					//{
					//	$("#place-stars li").eq(i).removeClass();
					//}, i * 80);
				}

				// OPENING HOURS
				if (place.opening_hours.open_now)
				{
					$("#place-open-now").html("Aperto adesso");
					$("#place-open-now").addClass("badge-success");
				}
				else
				{
					$("#place-open-now").html("Chiuso adesso");
					$("#place-open-now").addClass("badge-error");
				}

				console.log(place.opening_hours);

				["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"].forEach((dayName, dayIndex) =>
				{
					var trueDayIndex = dayIndex == 6 ? 0 : dayIndex + 1;
					var periods = place.opening_hours.periods.filter(p => p.open.day == trueDayIndex);

					var dayElement = $('<li/>');
					$('<b/>', { text: dayName }).appendTo(dayElement);
					var periodsWrapper = $('<span/>').appendTo(dayElement);

					if (periods && periods.length > 0)
					{
						periods.forEach(period =>
						{
							var time = period.open.hours.toLocaleString('it-IT', { minimumIntegerDigits: 2 }) + ':' + period.open.minutes.toLocaleString('it-IT', { minimumIntegerDigits: 2 });
							if (period.close)
							{
								time += '-' + period.close.hours.toLocaleString('it-IT', { minimumIntegerDigits: 2 }) + ':' + period.close.minutes.toLocaleString('it-IT', { minimumIntegerDigits: 2 });
							}
							$('<span/>', { text: time, class: 'd-block' }).appendTo(periodsWrapper);
						});
					}
					else
					{
						$('<span/>', { text: 'Chiuso', class: 'd-block' }).appendTo(periodsWrapper);
					}

					dayElement.appendTo('#place-opening-hours');
				});
			}
		}
	);
}

function addMarker(map)
{
	const refactoredPosition = { lat: locations[0].position.latitude, lng: locations[0].position.longitude }
	let iconPath = websitePath + "/assets/theme/img/logo/op-map-pin.png";
	let directionsDestination = "Orobica pesca, " + locations[0].position.address;

	// CUSTOM ICON
	if (locations[0].cashCarry)
	{
		iconPath = websitePath + "/assets/theme/img/logo/op-map-pin-cc.png";
	}

	// MARKER
	let marker = new google.maps.Marker({
		id: locations[0].id,
		//title: locations[0].name,
		position: refactoredPosition,
		//map,
		icon: {
			url: iconPath,
			scaledSize: new google.maps.Size(60, 60),
		},
	});

	marker.addListener('click', function ()
	{
		window.open("https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(directionsDestination), "_blank");
	});

	markers.push(marker);
	bounds.extend(refactoredPosition);

	// MARKER ANIMATION
	setTimeout(function ()
	{
		marker.setAnimation(google.maps.Animation.DROP);
		marker.setMap(map);
	}, 120);

	// MAP SET CENTER
	map.setCenter({ lat: locations[0].position.latitude, lng: locations[0].position.longitude });

	// INFO WINDOW
	let infowindow = new google.maps.InfoWindow({
		content: "<h5>Indicazioni stradali</h5>",
		ariaLabel: "Indicazioni",
		headerDisabled: true
	});

	// INFO WINDOW OPEN
	marker.addListener('mouseover', function ()
	{
		infowindow.open(map, this);
	});

	// INFO WINDOW CLOSE
	marker.addListener('mouseout', function ()
	{
		infowindow.close();
	});
}

function initMap()
{
	const map = new google.maps.Map(
		document.getElementById("map"),
		{
			zoom: 12,
			//styles: mapStyles,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			center: { lat: 45.6932349, lng: 9.6258901 }, // BG
		}
	);

	// When map ready add markers
	google.maps.event.addListenerOnce(map, 'idle', function ()
	{
		setTimeout(function ()
		{
			addPlaceDetails(map);
			addMarker(map);
		}, 500);
	});
}

$(document).ready(function ()
{
	//$("#map").height($("#map").width());
	const modelId = $("#map").data("model-id");

	// FETCH LOCATIONS
	$.ajax({
		url: "/gmap/locations/" + modelId,
		type: "GET",
		success: function (result)
		{
			locations = result;

			initMap();
		},
		error: function (jqXHR, textStatus, errorThrown)
		{
			console.log("!AJAX ERROR! " + errorThrown);
		}
	});
});